module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Postavi početak smene: " + _vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-timepicker', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "format": "HH:mm",
      "close-on-complete": "",
      "auto-scroll": "",
      "drop-direction": "auto"
    },
    model: {
      value: (_vm.choosedTime),
      callback: function($$v) {
        _vm.choosedTime = $$v
      },
      expression: "choosedTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": "Postavi",
      "name": "Postavi",
      "value": "Postavi"
    },
    on: {
      "click": function($event) {
        return _vm.changeTime()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec46753c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/ChangeCourierStartShift.vue
// module id = 515
// module chunks = 1